import React, { useState, useRef, useEffect } from 'react';
import TermsOfService from './TermsOfService';
import './TermsOfServiceModal.css';

interface TermsOfServiceModalProps {
  isOpen: boolean;
  onClose: () => void;
  onAccept: () => void;
  onDecline: () => void;
  forceAction?: boolean; // Không cho phép đóng modal nếu là true
}

const TermsOfServiceModal: React.FC<TermsOfServiceModalProps> = ({
  isOpen,
  onClose,
  onAccept,
  onDecline,
  forceAction = false
}) => {
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);
  const [isTermsAccepted, setIsTermsAccepted] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isOpen) {
      setHasScrolledToBottom(false);
      setIsTermsAccepted(false);
    }
  }, [isOpen]);

  const handleScroll = () => {
    if (contentRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
      const isScrolledToBottom = scrollTop + clientHeight >= scrollHeight - 10;
      setHasScrolledToBottom(isScrolledToBottom);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="terms-modal-overlay" onClick={forceAction ? undefined : onClose}>
      <div className="terms-modal" onClick={(e) => e.stopPropagation()}>
        <div className="terms-modal-header">
          <h2>Điều khoản sử dụng</h2>
          {!forceAction && (
            <button className="terms-modal-close" onClick={onClose}>
              ×
            </button>
          )}
        </div>
        
        <div 
          className="terms-modal-content"
          ref={contentRef}
          onScroll={handleScroll}
        >
          <TermsOfService className="compact" />
        </div>
        
        {!hasScrolledToBottom && (
          <div className="scroll-indicator">
            Cuộn xuống để đọc toàn bộ điều khoản
          </div>
        )}
        
        {hasScrolledToBottom && (
          <div className="terms-agreement-section">
            <label className="terms-agreement-checkbox">
              <input
                type="checkbox"
                checked={isTermsAccepted}
                onChange={(e) => setIsTermsAccepted(e.target.checked)}
              />
              <span className="checkmark"></span>
              <span className="agreement-text">
                Tôi đã đọc và đồng ý với điều khoản sử dụng
              </span>
            </label>
          </div>
        )}
        
        <div className="terms-modal-actions">
          
          <button 
            className={`terms-btn terms-btn-accept`}
            onClick={onAccept}
          >
            Đồng ý
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServiceModal;